export const adminUsers = {
  'admin.users.title': 'Gestión de Usuarios',
  'admin.users.subtitle': 'Gestionar y monitorear cuentas de usuario, estadísticas y rendimiento',
  'admin.users.loading': 'Cargando...',
  'admin.users.error': 'Error al cargar datos de usuarios',
  'admin.users.noData': 'No hay datos disponibles',
  'admin.users.cards.totalUsers.title': 'Total de Usuarios',
  'admin.users.cards.totalUsers.active': 'Activo',
  'admin.users.cards.totalUsers.inactive': 'Inactivo',
  'admin.users.cards.monthlyUsers.title': 'Nuevos Usuarios Este Mes',
  'admin.users.cards.monthlyUsers.dailyRegistrations': 'Registros de Hoy',
  'admin.users.cards.usersWithoutAccounts.title': 'Usuarios Sin Cuentas',
  'admin.users.cards.usersWithoutAccounts.withInactiveAccounts': 'Usuarios Con Cuentas Inactivas',
  'admin.users.cards.countryDistribution.title': 'Países Principales',
  'admin.users.cards.countryDistribution.topCountry': 'País Principal',
  'admin.users.cards.countryDistribution.usersCount': 'Cantidad de Usuarios',
  'admin.users.cards.countryDistribution.noData': 'No hay datos disponibles',
  'admin.users.cards.topEarnersCombined.title': 'Principales Ganadores Combinados',
  'admin.users.cards.topEarnersCombined.description': 'Trading + Ganancias de Comisión',
  'admin.users.cards.topEarnersAccounts.title': 'Principales Ganadores de Cuentas de Trading',
  'admin.users.cards.topEarnersAccounts.description': 'Ganancias de Cuentas de Trading',
  'admin.users.cards.topEarnersCommissions.title': 'Principales Ganadores de Comisiones',
  'admin.users.cards.topEarnersCommissions.description': 'Ganancias de Comisión de la Comunidad',
  'admin.users.tables.recent.title': 'Usuarios Recientes (Últimos 7 Días)',
  'admin.users.tables.inactive.title': 'Usuarios Inactivos',
  'admin.users.tables.no_accounts.title': 'Usuarios Sin Cuentas',
  'admin.users.tables.inactive_accounts.title': 'Usuarios con Cuentas Inactivas',
  'admin.users.tables.columns.username': 'Nombre de Usuario',
  'admin.users.tables.columns.name': 'Nombre',
  'admin.users.tables.columns.country': 'País',
  'admin.users.tables.columns.status': 'Estado',
  'admin.users.tables.columns.joinedAt': 'Se Unió En',
  'admin.users.tables.columns.accountCreationDate': 'Creación de Cuenta',
  'admin.users.tables.columns.accountNumber': 'Número de Cuenta',
  'admin.users.tables.columns.accountStatus': 'Estado de Cuenta',
  'admin.users.tables.columns.actions': 'Acciones',
  'admin.users.tables.status.active': 'Activo',
  'admin.users.tables.status.inactive': 'Inactivo',
  'admin.users.tables.accountStatus.active': 'Activo',
  'admin.users.tables.accountStatus.inactive': 'Inactivo',
  'admin.users.tables.accountStatus.pending': 'Pendiente',
  'admin.users.tables.accountStatus.suspended': 'Suspendido',
  'admin.users.tables.accountStatus.closed': 'Cerrado',
  'admin.users.tables.pagination.previous': 'Anterior',
  'admin.users.tables.pagination.next': 'Siguiente',
  'admin.users.tables.pagination.loadMore': 'Cargar Más',
  'admin.users.tables.pagination.showing': 'Mostrando',
  'admin.users.tables.pagination.of': 'de',
  'admin.users.tables.pagination.results': 'resultados',
  'admin.users.tables.pagination.page': 'Página',
  'admin.users.tables.error': 'Error al cargar datos de tabla',
  'admin.users.tables.noData': 'No hay datos disponibles',
  'admin.users.tables.noAccount': 'Sin Cuenta',
  'admin.users.tables.unknown': 'Desconocido',
  'admin.users.tables.viewProfile': 'Ver Perfil',
  // Search page translations
  'admin.users.search.title': 'Búsqueda de Usuarios',
  'admin.users.search.subtitle': 'Buscar y encontrar usuarios por varios criterios',
  'admin.users.search.form.userInfo.label': 'Información del Usuario',
  'admin.users.search.form.userInfo.placeholder': 'Buscar por nombre de usuario, nombre, email o teléfono...',
  'admin.users.search.form.country.label': 'País',
  'admin.users.search.form.country.placeholder': 'Seleccionar un país...',
  'admin.users.search.form.country.all': 'Todos los Países',
  'admin.users.search.form.searchButton': 'Buscar',
  'admin.users.search.form.clearButton': 'Limpiar',
  'admin.users.search.results.title': 'Resultados de Búsqueda',
  'admin.users.search.results.noResults': 'No se encontraron usuarios que coincidan con sus criterios',
  'admin.users.search.results.loading': 'Buscando usuarios...',
  'admin.users.search.results.error': 'Error al buscar usuarios',
  'admin.users.search.results.showEmail': 'Mostrar Email',
  'admin.users.search.results.hideEmail': 'Ocultar Email',
  'admin.users.search.results.showPhone': 'Mostrar Teléfono',
  'admin.users.search.results.hidePhone': 'Ocultar Teléfono',
  'admin.users.search.results.columns.email': 'Email',
  'admin.users.search.results.columns.phone': 'Teléfono',
  
  // Profile page
  'admin.users.profile.title': 'Perfil de Usuario',
  'admin.users.profile.subtitle': 'Ver información detallada del usuario y configuraciones',
  'admin.users.profile.error.userNotFound': 'Usuario no encontrado. El nombre de usuario especificado no existe.',
  'admin.users.profile.loading': 'Cargando perfil de usuario...',
  
  // Profile information section
  'admin.users.profile.info.title': 'Información del Perfil',
  'admin.users.profile.info.username': 'Nombre de Usuario',
  'admin.users.profile.info.name': 'Nombre',
  'admin.users.profile.info.status': 'Estado del Usuario',
  'admin.users.profile.info.memberSince': 'Miembro Desde',
  'admin.users.profile.info.sponsor': 'Patrocinador',
  'admin.users.profile.info.referralLink': 'Enlace de Referido',
  'admin.users.profile.info.commissionModel': 'Modelo de Comisión',
  'admin.users.profile.info.country': 'País',
  'admin.users.profile.info.domain': 'Dominio',
  'admin.users.profile.info.internalCommissionModel': 'Modelo de Comisión Interno',
  'admin.users.profile.info.communityLevel': 'Nivel de Comunidad',
  'admin.users.profile.info.genealogyTree': 'Árbol Genealógico de la Comunidad',
  'admin.users.profile.info.openUserTree': 'Abrir Árbol del Usuario',
  'admin.users.profile.info.copyReferralLink': 'Copiar Enlace de Referido',
  'admin.users.profile.info.viewSponsor': 'Ver Perfil del Patrocinador',
  'admin.users.profile.info.noData': 'La información del perfil no está disponible.',
  
  // User status editing
  'admin.users.profile.status.editButton': 'Editar Estado',
  'admin.users.profile.status.saveButton': 'Guardar',
  'admin.users.profile.status.cancelButton': 'Cancelar',
  'admin.users.profile.status.saving': 'Guardando...',
  'admin.users.profile.status.active': 'Activo',
  'admin.users.profile.status.inactive': 'Inactivo',
  'admin.users.profile.status.updateSuccess': 'Estado Actualizado',
  'admin.users.profile.status.updateSuccessDescription': 'El estado del usuario se ha actualizado correctamente.',
  'admin.users.profile.status.updateError': 'Error al Actualizar',
  'admin.users.profile.status.updateErrorDescription': 'No se pudo actualizar el estado del usuario. Por favor, intente nuevamente.',
  
  // Private information section
  'admin.users.profile.private.title': 'Información Privada',
  'admin.users.profile.private.subtitle': 'Detalles personales confidenciales del usuario',
  'admin.users.profile.private.email': 'Correo Electrónico',
  'admin.users.profile.private.phone': 'Número de Teléfono',
  'admin.users.profile.private.gender': 'Género',
  'admin.users.profile.private.noData': 'La información privada no está disponible.',
  
  // Payment methods section
  'admin.users.profile.payment.title': 'Métodos de Pago',
  'admin.users.profile.payment.subtitle': 'Opciones de pago configuradas del usuario',
  'admin.users.profile.payment.crypto.title': 'Billetera Cripto',
  'admin.users.profile.payment.crypto.network': 'Red',
  'admin.users.profile.payment.crypto.currency': 'Moneda',
  'admin.users.profile.payment.crypto.address': 'Dirección',
  'admin.users.profile.payment.noData': 'No hay métodos de pago configurados.',

  // User Accounts Section
  profileUserAccounts: 'Cuentas de Usuario',
  profileUserAccountsSubtitle: 'Cuentas de trading y detalles de inversión',
  profileAccountsTableAccountNumber: 'Número de Cuenta',
  profileAccountsTableAccountStatus: 'Estado de Cuenta',
  profileAccountsTableAccountType: 'Tipo de Cuenta',
  profileAccountsTableProgramPercent: 'Porcentaje de Programa',
  profileAccountsTableBalance: 'Saldo',
  profileAccountsTableCreationDate: 'Creación de Cuenta',
  profileAccountsTableNoData: 'No hay datos de cuentas disponibles',
  profileAccountsTableError: 'Error al cargar datos de cuentas',

  // User Earnings Section
  profileUserEarnings: 'Información de Ganancias del Usuario',
  profileUserEarningsSubtitle: 'Resumen integral de ganancias y beneficios',
  profileEarningsError: 'Error al cargar datos de ganancias',
  profileEarningsNoData: 'No hay datos de ganancias disponibles',
  
  // Admin profile earnings keys
  'admin.users.profile.earnings.title': 'Información de Ganancias del Usuario',
  'admin.users.profile.earnings.subtitle': 'Resumen integral de ganancias y beneficios',
  
  // Historic Earnings Section
  'admin.users.profile.historicEarnings.title': 'Información Histórica de Ganancias del Usuario',
  'admin.users.profile.historicEarnings.subtitle': 'Vista completa histórica de cuentas y ganancias por comisiones',
  'admin.users.profile.historicEarnings.error.userIdRequired': 'Se requiere ID de usuario para cargar datos de ganancias',
  'admin.users.profile.historicEarnings.accountsHistory.title': 'Historial de Ganancias de Cuentas',
  'admin.users.profile.historicEarnings.accountsHistory.subtitle': 'Datos históricos de ganancias de cuentas de inversión del usuario',
  'admin.users.profile.historicEarnings.accountsHistory.error': 'Error al cargar historial de ganancias de cuentas',
  'admin.users.profile.historicEarnings.commissionsHistory.title': 'Historial de Ganancias por Comisiones',
  'admin.users.profile.historicEarnings.commissionsHistory.subtitle': 'Ganancias históricas por comisiones de la red de referidos',
  'admin.users.profile.historicEarnings.commissionsHistory.error': 'Error al cargar historial de ganancias por comisiones',
  
  // Payment History Section
  'admin.users.profile.paymentHistory.title': 'Historial de Pagos del Usuario',
  'admin.users.profile.paymentHistory.subtitle': 'Registro completo de pagos de comisiones y transacciones',
  'admin.users.profile.paymentHistory.error.userIdRequired': 'Se requiere ID de usuario para cargar datos de pagos',
  'admin.users.profile.paymentHistory.error.loadingData': 'Error al cargar datos del historial de pagos',

  // Admin Community Levels
  'admin.users.communityLevels.title': 'Niveles de Comunidad',
  'admin.users.communityLevels.subtitle': 'Explora la estructura de la comunidad por niveles jerárquicos',
  'admin.users.communityLevels.targetUser': 'Usuario Objetivo',
  'admin.users.communityLevels.level': 'Nivel',
  'admin.users.communityLevels.members': 'miembros',
  'admin.users.communityLevels.total': 'total',
  'admin.users.communityLevels.active': 'Activo',
  'admin.users.communityLevels.inactive': 'Inactivo',
  'admin.users.communityLevels.treeLevel': 'Nivel del Árbol',
  'admin.users.communityLevels.directReferrals': 'Referidos Directos',
  'admin.users.communityLevels.memberSince': 'Miembro Desde',
  'admin.users.communityLevels.username': 'Usuario',
  'admin.users.communityLevels.name': 'Nombre',
  'admin.users.communityLevels.country': 'País',
  'admin.users.communityLevels.joinDate': 'Fecha de Ingreso',
  'admin.users.communityLevels.status': 'Estado',
  'admin.users.communityLevels.loading': 'Cargando...',
  'admin.users.communityLevels.loadMore': 'Cargar Más',
  'admin.users.communityLevels.noMembers': 'No se encontraron miembros para este nivel',
  'admin.users.communityLevels.errorLoading': 'Error al cargar datos del nivel',
  'admin.users.communityLevels.errorLoadingData': 'Error al cargar datos de la comunidad',
  'admin.users.communityLevels.userNotFound': 'Usuario no encontrado',
  'admin.users.communityLevels.noCommunityData': 'No hay datos de comunidad disponibles',
  'admin.users.communityLevels.filters': 'Filtros',
  'admin.users.communityLevels.statusFilter': 'Filtro de Estado',
  'admin.users.communityLevels.rankFilter': 'Filtro de Rango',
  'admin.users.communityLevels.allStatuses': 'Todos los Estados',
  'admin.users.communityLevels.allRanks': 'Todos los Rangos',
  'admin.users.communityLevels.communityStructure': 'Estructura de la Comunidad',
};